import {gql, useMutation} from "@apollo/client";

const EDIT_GAME_MUTATION = gql`
mutation EditGame($gameId: Int!, $fieldId: Int!, $homeTeamId: String!, $visitorTeamId: String!, $dateTime: String!, $timezone: String!, $refereeIds: [Int], $managerIds: [Int], $description: String) {
  editGame(gameId: $gameId, fieldId: $fieldId, homeTeamId: $homeTeamId, visitorTeamId: $visitorTeamId, dateTime: $dateTime, timezone: $timezone, refereeIds: $refereeIds, managerIds: $managerIds, description: $description) {
    game{
        id
        name
        homeTeam{
            id
            name
            logo
        }
        homeTeamAlias
        visitorTeam{
            id
            name
            logo
        }
        visitorTeamAlias
        group{
            id
            name
        }
        matchDay
        gameAlias
        homeAway
        noPlay
        scoreHome
        scoreVisitor
        penaltiesHome
        penaltiesVisitor
        event{
            id
            title
            description
            status
            date
            timezone
            stage{
                id
                name
                scheduleType
            }
            field{
                id
                name
            }
            responsibles
            managers
        }
    }
    success
    message
    errorData{
        name
        event{
            date
            field{
                name
            }
        }
    }
  }
}
`;

export default function EditGameMutation() {
    return useMutation(EDIT_GAME_MUTATION);
}
